import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { CreateUserAccount, ChoosePassword, VerifyOTP, StepSuccess } from '../../molecules';
import { DefaultLayout } from '../../layouts';
import { UserContext } from '../../../context';
import { default as t } from '../../../utils/i18n';

const SignUp = props => {
  const location = useLocation();
  const { user } = useContext(UserContext);
  const { signup } = user;
  const [signUpStep, setSignUpStep] = useState(1);

  useEffect(()=>{
     if (!user?.authenticated) {
        window.location.replace(`${process.env.REACT_APP_UPA_BASE_URL}/signout`)
}
  },[user])

  useEffect(() => {
    if (user?.isVerifyOtp) {
      setSignUpStep(3);
    } else if (signup?.step) {
      setSignUpStep(signup.step);
    } else {
      setSignUpStep(1);
    }
  });

  return (
    <DefaultLayout>
      {signUpStep === 1 ? (
        <CreateUserAccount atStep={signUpStep} updateStep={setSignUpStep} />
      ) : null}
      {signUpStep === 2 ? <ChoosePassword atStep={signUpStep} updateStep={setSignUpStep} /> : null}
      {signUpStep === 3 ? <VerifyOTP atStep={signUpStep} updateStep={setSignUpStep} /> : null}
      {signUpStep === 4 ? (
        <StepSuccess
          heading={t('signup.step4.heading')}
          subheading={t('signup.step4.subheading')}
          buttonText={t('signup.button.signIn')}
          navigationURL={'/signIn'}
        />
      ) : null}
    </DefaultLayout>
  );
};

export default SignUp;
